import './hotspot-selector/hotspot-selector.tag'

riot.tag2('cor-mj-munis-hotspots', '<hotspot-selector ref="hotspot-selector"></hotspot-selector>', '', '', function(opts) {
});



// WEBPACK FOOTER //
// ./src/components/hotspots.tag